import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { dateDbToBr } from '../../utils/Funcoes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faCalendarCheck, faEdit, faPaw, faPlus, faTrash, faUser } from '@fortawesome/free-solid-svg-icons'
import { statusAgendamentosUtils } from '../../utils/statusAgendamentosUtils'
import { tiposAgendamentosUtils } from '../../utils/tiposAgendamentosUtils'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

const   AgendamentosListMobile = ({ listAgendamentos, handleClickMobileEnvent, startDate, handleEventDelete }) => {


    const [listaAg, setlistaAg] = useState([])
    const list = () => {

        let corStatus = statusAgendamentosUtils()


        let agendamentos = []
        listAgendamentos?.map((item) => {

            let animais = null
            if (item?.animais_clientes.length > 0) {
                animais = item?.animais_clientes[0]
            }
            let dataInicio = item.inicio.split(' ')
            let dataFim = item.termino?.split(' ')
            let servico = (item?.agendamento_itens?.length > 0) ? item?.agendamento_itens[0] : '';
            let tipoAgendamento = tiposAgendamentosUtils().find(tp => tp.id == item.tipoAgendamentoId)



            agendamentos.push({
                id: item.id,
                tipoAgendamento: tipoAgendamento,
                inicio: item.inicio.replace(' ', 'T'),
                data: dateDbToBr(dataInicio[0]),
                hora: dataInicio[1].substring(0, 5),
                dataFim: (dataFim != undefined) ? dateDbToBr(dataFim[0]) : '',
                horaFim: (dataFim != undefined) ? dataFim[1].substring(0, 5) : '',
                nomeCliente: item?.clientes?.nome,
                animal: (animais != null) ? animais : '',
                observacoes: item.observacoes,
                dadosServicos: (servico != '') ? servico.nomeServico : '',
                statusCor: corStatus.find(cor => cor.id == item.status)

            })
            setlistaAg(agendamentos)
        })



    }

    useEffect(() => {
        setlistaAg([])
        list()
    }, [listAgendamentos])


   // console.log(startDate)
    return (
        <>
            <div className='box-fundo animate-fade-in flex'>
                <Row>
                    <Col xs={12} md={12}>

                        <h5 className='bold text-primary '>
                            {format(startDate, " dd 'de' MMMM - EEEE", { locale: ptBR })}

                        </h5>

                    </Col>
                
                </Row>



                <div id="divListEvents" className='mt-15'>

                    {(listaAg.length > 0) ? (
                        <>
                            {listaAg?.map((item) => (

                                <div id="eventMobile" className='animate-fade-in'
                                    style={{ background: item.statusCor?.colorLight, border: '1px solid ' + item.statusCor?.color }}
                                >

                                    <div className="corStatus" style={{ background: item.statusCor?.color }}>


                                    </div>
                                    <div style={{ flex: 1, padding: '5px' }}>
                                        <Row>
                                            <Col>
                                                <div className='info_horario bold'>
                                                    {item?.tipoAgendamento?.nome}<br></br>
                                                    <FontAwesomeIcon icon={faCalendar} />   {item.hora}h
                                                    {(item.dataFim != '' && item.dataFim != item.data) ? (
                                                        <>
                                                            {' até ' + item.dataFim + ' - ' + item.horaFim + 'h'}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {(item.horaFim != '') ? ' até ' + item.horaFim + 'h' : ''}
                                                        </>
                                                    )
                                                    }
                                                    - <span style={{ fontWeight: 'initial' }}> {item.statusCor?.nome}  </span>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <FontAwesomeIcon icon={faUser} />   <span className='vertical-mid'>{item.nomeCliente}</span>
                                            </Col>
                                            <Col>
                                                <FontAwesomeIcon icon={faPaw} /> <span className='vertical-mid'>{item?.animal?.nome}</span>
                                            </Col>
                                        </Row>


                                        <Row>
                                            <Col>
                                                {item.dadosServicos}<br></br>
                                                <label>Obs:</label> {item.observacoes}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <div className='text-right'>
                                                <Button variant='info' className='mr-15' size='sm' onClick={() => handleClickMobileEnvent(item.id, item.inicio)}><FontAwesomeIcon icon={faEdit} /></Button>
                                                <Button variant='danger' size='sm' onClick={() => handleEventDelete(null, item.id)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></Button>
                                            </div>
                                        </Row>
                                    </div>

                                </div>

                            )
                            )}
                        </>) : <div className='alert alert-warning'>Sem agendamentos neste dia</div>
                    }

                </div>
            </div>
        </>
    )
}
export default AgendamentosListMobile;